var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "cw-shelf",
        },
        [
          _c("courseware-unit-items"),
          _vm._v(" "),
          !_vm.inCourseContext ? _c("courseware-shared-items") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showUnitAddDialog ? _c("courseware-shelf-dialog-add") : _vm._e(),
      _vm._v(" "),
      _vm.showUnitCopyDialog ? _c("courseware-shelf-dialog-copy") : _vm._e(),
      _vm._v(" "),
      _vm.showUnitImportDialog
        ? _c("courseware-shelf-dialog-import")
        : _vm._e(),
      _vm._v(" "),
      _vm.userIsTeacher || !_vm.inCourseContext
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#courseware-action-widget",
                name: "sidebar-actions",
              },
            },
            [_c("courseware-shelf-action-widget")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userIsTeacher || !_vm.inCourseContext
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#courseware-import-widget",
                name: "sidebar-imports",
              },
            },
            [_c("courseware-shelf-import-widget")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("courseware-companion-overlay"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }